import Vue from 'vue'
/*
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
const nodeEnv = process.env.NODE_ENV;  // development or production
if(nodeEnv == 'development') {
  Sentry.init({
    dsn: "https://dd5ccaf935e648a8a9584c1fdf831e4e@o408603.ingest.sentry.io/5466311",
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],
  
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}
*/
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

import {debug} from "@/api/logging"
import store from './store'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'

import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin)
// import VueVirtualScroller from 'vue-virtual-scroller'
// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
// Vue.use(VueVirtualScroller)
Vue.config.productionTip = false
const u = require("@/api/util.js")
import {column_name_mapping} from "@/api/mappings"
import i18n from './i18n'
debug('i18n', i18n.locale, i18n.messages)
Vue.prototype.$abbr = (v) => {
  const key = i18n.locale == 'en' ? i18n.t('abbr.' + v) : v
  return i18n.t(key)
  // return i18n.t(i18n.t('abbr.' + v).replace('abbr.', ''))
}

// lang based field name
// const en_map = {
//   "intro": "intro_en",
//   "journal_name": "journal_en_name",
//   "status": "status_en",
//   "interval": "interval_en",
//   "publish": "publish_en",
//   "city": "city_en",
//   "period": "period_en",
//   "name": "name_en",
//   "desc": "desc_en",
//   "desc_short": "desc_en",
// }

// Vue.prototype.$en = (v) => {
//   if(i18n.locale == 'en') {
//     if(en_map[v] !== undefined) return en_map[v]
//   }
//   return v
// }
Vue.prototype.$en = u.$en
Vue.prototype.$u = u
Vue.prototype.$mm = column_name_mapping
Vue.prototype.$q = (q) => {
  // return q
  if(store.state.test !== store.state.test_default) {
      return Object.assign({}, q, {test: store.state.test ? 1 : 0})
  }
  return q
}
/*
const resolve_ = router.resolve
router.resolve = (to, current, append)=>{
  to = resolve_.call(router, to, current, append)
  debug('to', to)
  const {location} = to
  const {query} = location
  if(query && !('test' in query)) {
    if(store.state.test !== store.state.test_default) {
      query['test'] = store.state.test ? 1 : 0
      const to_ = Object.assign({}, location, {query})
      const rr = resolve_.call(router, to_, current, append)
      debug('rr', rr)
      return rr
    }
  }
  return to
}
*/
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
